import { Card, Text, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { AdmissionEncounter } from '@seen/core/models/encounters/admission-encounter'
import { ExtendedLocation } from '@seen/core/models/location'
import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { useParams } from 'react-router'
import { EditAdmission } from '#src/components/admission/EditAdmission.tsx'
import { DataDisplay } from '#src/components/display/DataDisplay.tsx'
import { DateDisplay } from '#src/components/display/DateTimeDisplay.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function AdmissionDisplayPage(): JSX.Element {
  const { encounterId } = useParams()
  const [showEditModal, { open: openEditModal, close: closeEditModal }] =
    useDisclosure(false)

  const { data: admission, isLoading: isAdmissionLoading } = useRead(
    AdmissionEncounter,
    encounterId
  )
  const { data: location, isLoading: isLocationLoading } = useRead(
    ExtendedLocation,
    admission?.location
  )

  if (isAdmissionLoading || isLocationLoading) {
    return <div>Loading...</div>
  }

  if (!admission) {
    return <div>Admission not found</div>
  }

  return (
    <>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Title order={2}>Admission Details</Title>
          <div className="flex justify-end">
            <Button variant="outline" onClick={openEditModal}>
              Edit Admission
            </Button>
          </div>
        </div>
        <Card withBorder>
          <Title order={3}>Overview</Title>
          <div className="space-y-4 mt-2">
            <DataDisplay label="Type" value={<Text>Hospital Inpatient</Text>} />
            <DataDisplay
              label="Status"
              value={<Text>{admission.status}</Text>}
            />
            <DataDisplay
              label="Location"
              value={<Text>{location?.name ?? 'Unknown'}</Text>}
            />
            <DataDisplay
              label="Start Date"
              value={<DateDisplay value={admission.startTime} />}
            />
            <DataDisplay
              label="End Date"
              value={<DateDisplay value={admission.endTime} />}
            />
          </div>
        </Card>
      </div>

      <EditAdmission
        admission={admission}
        open={showEditModal}
        onOpenChange={(isOpen) => {
          if (isOpen) {
            openEditModal()
          } else {
            closeEditModal()
          }
        }}
      />
    </>
  )
}
